export default __webpack_public_path__ + "static/media/main.a118f26a.jpg";